/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserMiniReference,
    ElementsUserMiniReferenceFromJSON,
    ElementsUserMiniReferenceFromJSONTyped,
    ElementsUserMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetRatingUpdate
 */
export interface AssetRatingUpdate {
    /**
     * 
     * @type {ElementsUserMiniReference}
     * @memberof AssetRatingUpdate
     */
    user: ElementsUserMiniReference;
    /**
     * 
     * @type {number}
     * @memberof AssetRatingUpdate
     */
    rating?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetRatingUpdate
     */
    asset: number;
}

export function AssetRatingUpdateFromJSON(json: any): AssetRatingUpdate {
    return AssetRatingUpdateFromJSONTyped(json, false);
}

export function AssetRatingUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetRatingUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': ElementsUserMiniReferenceFromJSON(json['user']),
        'rating': !exists(json, 'rating') ? undefined : json['rating'],
        'asset': json['asset'],
    };
}

export function AssetRatingUpdateToJSON(value?: AssetRatingUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': ElementsUserMiniReferenceToJSON(value.user),
        'rating': value.rating,
        'asset': value.asset,
    };
}


